import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authorized-container',
  templateUrl: './authorized-container.component.html',
  styleUrls: ['./authorized-container.component.css']
})
export class AuthorizedContainerComponent implements OnInit {
  sidebarCollapsed = false;
  isRtl = false;
  isMobileView = window.innerWidth <= 768;

  ngOnInit() {
    window.addEventListener('resize', () => {
      this.isMobileView = window.innerWidth <= 768;
    });
  }

  toggleSidebar() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  toggleLang() {
    this.isRtl = !this.isRtl;
  }
}
